import { create } from 'zustand';

export interface Wallet {
  id: string;
  familyId: string;
  ownerId: string;
  name: string;
  type: 'shared' | 'personal';
  color: string;
}

interface WalletsStore {
  wallets: Wallet[];
  selectedWalletId: string;
  setWallets: (wallets: Wallet[]) => void;
  selectWallet: (id: string) => void;
  reset: () => void;
}

export const useWalletsStore = create<WalletsStore>((set) => ({
  wallets: [],
  selectedWalletId: 'all', // 'all' = pseudo wallet "Wspólny" agregujący wszystkie
  setWallets: (wallets) => set({ wallets }),
  selectWallet: (id) => set({ selectedWalletId: id }),
  reset: () => set({ wallets: [], selectedWalletId: 'all' }),
}));
